<script setup>
import { to } from "await-to-js";
import dayjs from "dayjs";
import range from "lodash/range";
import get from "lodash/get";
import includes from "lodash/includes";
import remove from "lodash/remove";
import { Delete, Close, Switch } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { interceptor } from "@dutypay/utilities";
//const createOSSCorrectionProjectForm = ref({});
const OSSCorrectionProject = ref({});
const OSSShowUploadList = ref([]);
const OSSCorrectionFileTypes = ref(["original", "current"]);
const OSSCurrentQuarter = ref("");
const quartersList = ref([]);
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  quarters();
  await getOSSCorrectionProject(route.params.id);
});

const showUpload = (formName) => {
  if (!includes(OSSShowUploadList.value, formName)) {
    OSSShowUploadList.value.push(formName);
  }
};

const hideUpload = (formName) => {
  OSSShowUploadList.value = remove(OSSShowUploadList.value, formName);
};

const processOSSReportUpload = async (data) => {
  const envStore = useEnvStore();
  let filenameSplit = data.filename.split("-");
  let type = filenameSplit[0];
  let quarter = filenameSplit[1] + "-" + filenameSplit[2];

  let uploadData = {
    file: data.file,
    originalFileName: data.file.name,
    type: type,
    quarter: quarter,
    formName: data.filename,
    id: OSSCorrectionProject.value["hs.oss.correction.project.id"],
  };

  let formData = new FormData();

  for (var key in uploadData) {
    formData.append(key, uploadData[key]);
  }

  let err;
  [err] = await to(
    interceptor.post(
      `${envStore.apiUrls.dutypay}/api/v0/tools/oss-report/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
  );
  if (err) {
    console.log(err);
  }
  hideUpload(data.filename);
  await getOSSCorrectionProject(route.params.id);
};

const deleteOSSReportUpload = async (formName) => {
  const envStore = useEnvStore();
  let err;
  [err] = await to(
    interceptor.delete(
      `${envStore.apiUrls.dutypay}/api/v0/tools/oss-report/upload`,
      {
        data: {
          formName: formName,
          id: route.params.id,
        },
      }
    )
  );
  if (err) {
    console.log(err);
  }
  await getOSSCorrectionProject(route.params.id);
};

const submitOSSCorrectionData = async () => {
  const envStore = useEnvStore();
  let err, file;
  [err,file] = await to(
    interceptor.post(
      `${envStore.apiUrls.dutypay}/api/v0/tools/oss-correction/calculate`,
      {
        id: route.params.id,
      },
      {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/xlsx'
        }
      }
    )
  );
  const url = window.URL.createObjectURL(new Blob([file.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'file.xlsx'); //or any other extension
  document.body.appendChild(link);
  link.click();

  if (err) {
    console.log(err);
  }
  await getOSSCorrectionProject(route.params.id);
};

const getOSSCorrectionProject = async (id) => {
  const envStore = useEnvStore();
  let err, res;
  [err, res] = await to(
    interceptor.get(
      `${envStore.apiUrls.dutypay}/api/v0/tools/oss-correction-projects/${id}`,
      {
        params: {},
      }
    )
  );
  if (err) {
    OSSCorrectionProject.value = {};
    return;
  }
  OSSCorrectionProject.value = res.data.result.OSSCorrectionProject;
};

const quarters = () => {
  let currentYear = parseInt(dayjs().format("YYYY"), 10);
  let currentMonth = parseInt(dayjs().format("M"), 10);
  let currentQuarter = Math.round(currentMonth / 4) + 1;
  const years = range(2021, parseInt(currentYear, 10) + 1);
  years.forEach((year) => {
    if (year == 2021) {
      quartersList.value.push(year + "-3");
      quartersList.value.push(year + "-4");
      return;
    }
    if (year == currentYear) {
      let validQuarters = range(1, currentQuarter);
      validQuarters.forEach((q) => {
        quartersList.value.push(year + "-" + q);
      });
      return;
    }
    quartersList.value.push(year + "-1");
    quartersList.value.push(year + "-2");
    quartersList.value.push(year + "-3");
    quartersList.value.push(year + "-4");
    
  });
  if(currentQuarter == 1){
    currentYear = currentYear - 1;
    currentQuarter = 4;
  }
  if(currentMonth > 3 && currentMonth <=6){
    currentQuarter = 1;
  }
  if(currentMonth > 6 && currentMonth <= 9){
    currentQuarter = 2;
  }
  if(currentMonth > 9 && currentMonth <= 12){
    currentQuarter = 3;
  }
  OSSCurrentQuarter.value = currentYear + "-" + currentQuarter;
  console.log(currentYear + "-" + currentQuarter);
};
</script>

<script>
import { useEnvStore } from "@dutypay/store-modules";
//import { to } from "await-to-js";
import { mapState } from "pinia";
export default {
  name: "OSSCorrectionProjectDetails",
  computed: {
    ...mapState(useEnvStore, ["apiUrls"]),
  },
  methods: {
    printError(err) {
      if (this.debug) {
        this.$dp.log(err);
      }
    },
  },
};
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-button type="default" @click="router.push({path: '/tools/oss-correction'})">Back to the OSS correction projects</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <h1>
          OSS Correction Project:
          {{
            OSSCorrectionProject["property.value.en-US"] +
            " " +
            dayjs(OSSCorrectionProject["creation.startDate"]).format(
              "DD.MM.YYYY HH:mm:ss"
            )
          }}
        </h1>

        <el-row
          :gutter="20"
          v-for="(quarter, key) in quartersList"
          v-bind:key="key"
          style="padding: 1rem; border-bottom: 1px solid #000"
        >
          <el-col :span="4">
            {{ quarter }}
          </el-col>
          <el-col
            :span="10"
            v-bind:key="index"
            v-for="(type, index) in OSSCorrectionFileTypes"
          >
            <div
              v-show="
                (!get(
                  OSSCorrectionProject,
                  ['upload.data', quarter, type],
                  undefined
                ) ||
                includes(
                  OSSShowUploadList,
                  get(
                    OSSCorrectionProject,
                    ['upload.data', quarter, type, 'formName'],
                    undefined
                  )
                ))
                && !(type + '-' + quarter == 'original-' + OSSCurrentQuarter)
              "
            >
              <el-upload
                :ref="type + '-' + quarter"
                :name="type + '-' + quarter"
                :http-request="processOSSReportUpload"
                :multiple="false"
                :show-file-list="false"
                accept=".xlsx"
              >
                <template #trigger>
                  <el-button :type="type == 'original' ? 'warning' : 'success'"
                    >Select {{ type }} Report</el-button
                  >
                </template>
              </el-upload>
              <el-button
                type="danger"
                :icon="Close"
                style="float: right"
                @click="
                  hideUpload(
                    get(
                      OSSCorrectionProject,
                      ['upload.data', quarter, type, 'formName'],
                      {}
                    )
                  )
                "
                v-show="
                  get(
                    OSSCorrectionProject,
                    ['upload.data', quarter, type],
                    undefined
                  )
                "
              ></el-button>
            </div>
            <div
              v-show="
                get(
                  OSSCorrectionProject,
                  ['upload.data', quarter, type],
                  undefined
                ) &&
                !includes(
                  OSSShowUploadList,
                  get(
                    OSSCorrectionProject,
                    ['upload.data', quarter, type, 'formName'],
                    undefined
                  )
                )
              "
            >
              {{
                get(
                  OSSCorrectionProject,
                  ["upload.data", quarter, type, "originalFileName"],
                  {}
                )
              }}
              <div style="float: right">
                <el-button
                  type="warning"
                  :icon="Switch"
                  @click="
                    showUpload(
                      get(
                        OSSCorrectionProject,
                        ['upload.data', quarter, type, 'formName'],
                        {}
                      )
                    )
                  "
                ></el-button>
                <el-button
                  type="danger"
                  :icon="Delete"
                  @click="
                    deleteOSSReportUpload(
                      get(
                        OSSCorrectionProject,
                        ['upload.data', quarter, type, 'formName'],
                        {}
                      )
                    )
                  "
                ></el-button>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="padding: 1rem">
          <el-col :span="24" style="text-align: center">
            <el-button type="primary" @click="submitOSSCorrectionData"
              >Calculate</el-button
            >
          </el-col>
        </el-row>

      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.form-inline .el-input {
  --el-input-width: 220px;
}
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
